import { api } from './client';
import { API_BASE_URL } from '../config/api';
import { parseStoreStatus } from '../utils/storeStatus';

export async function fetchStoreStatus() {
  const { data } = await api.get(`${API_BASE_URL}/storeSettings/status`, { timeoutMs: 15000 });
  return parseStoreStatus(data);
}
